import type { AiEvent } from "@/hooks/useAiAgent";

export function aiEventDateLabel(event: AiEvent): string {
  if (event.date) {
    return new Date(event.date).toLocaleDateString("pl-PL", {
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "Europe/Warsaw",
    });
  }
  const metadata = event.collectionMetadata;
  if (metadata?.datePrecision === "date" && metadata.start) {
    return `${metadata.start}${metadata.end ? ` – ${metadata.end}` : ""} · ${metadata.end ? "bez godzin" : metadata.isAllDay ? "całodniowe" : "brak godziny"}`;
  }
  return "Termin do uzupełnienia";
}
